import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { DatePicker } from "../../../Common/Controls/Controls";
import { requestAxios, ComboBox } from "../../../../util/util";
import AppContext from "../../../../Context/AppContext";

const ModalEtapa1 = ({ show, setShow, currentDemanda, currentEtapa, loadInfoParent }) => {
  const { checkUserSession, contextAcreditado, changeLoading } =
    useContext(AppContext);
  const infoUs = checkUserSession();
  const [currentEtapaUpdate, setCurrentEtapaUpdate] = useState(currentEtapa);
  const [listEtapaProcesal, setListEtapaProcesal] = useState([]);
  const [validated, setValidated] = useState(false);
  const acreditadoInfo = contextAcreditado.getInfoAcreditado();
  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    var listEtapas = await ComboBox.cmbEtapasDisponibles(
      infoUs,
      currentDemanda==null?currentEtapa.AsigDemandaId:currentDemanda.AsigDemandaId,
      currentEtapa.EtapaId,
      currentEtapa.exist
    );
    setListEtapaProcesal(listEtapas);
  }
  function updateEtapa(field, value) {
    const newCurrentEtapaUpdate = { ...currentEtapaUpdate };
    newCurrentEtapaUpdate[field] = value;
    setCurrentEtapaUpdate(newCurrentEtapaUpdate);
  }
  function setFecha1(date) {
    updateEtapa("AsigDEFechaInicio", date);
  }
  function setFecha2(date) {
    updateEtapa("AsigDEFechaFinal", date);
  }
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    if (form.checkValidity() === true) {
      saveData();
    }
  };
  async function saveData() {
    changeLoading(true);
    currentEtapaUpdate.AsigDemandaId=currentDemanda!=null?currentDemanda.AsigDemandaId:currentEtapaUpdate.AsigDemandaId;
    currentEtapaUpdate.EtapaId=currentEtapaUpdate.EtapaId;
    
    const { error, data } = await requestAxios({
      url: `Demandas/${
        currentEtapaUpdate.exist != null ? "UEtapaProcesal" : "IEtapaProcesal"
      }`,
      
      method: currentEtapaUpdate.exist != null ? "put" : "post",
      token: infoUs.bearer_token,
      data: currentEtapaUpdate,
    });
    console.log(data);
    changeLoading(false);
    if (error === "") {
      const MySwal = withReactContent(Swal);
      if(data === "ok") {
        await MySwal.fire({
          title: <strong>Hecho!</strong>,
          html: <i>Guardado con éxito!</i>,
          icon: "success",
        });
      } else {
        await MySwal.fire({
          title: <strong>Error!</strong>,
          html: <i>Verificar la información!</i>,
          icon: "error",
        });
      }

      changeLoading(false);
      loadInfoParent()
     } else {
      alert("Error, try again");
    }
  }
  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90wEtapa1"
        className={`ModalNuevaEtapa `}
      >
        <h1 className="ModelEtapa1_titulo">
          <span className="ModelEtapa1_Subtitulo">Nueva Etapa</span>
        </h1>
        <br />

        <h5 className="ModelEtapa1_text">
          Rellene los campos y pulse guardar.
        </h5>
        <br />

        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="ModelEtapa1_Acreditado">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Etapa</InputLabel>
                <Select
                  required
                  className="cmbTipoGestion"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={<div className="cmbTipoGestionTitle">Etapa</div>}
                  value={currentEtapaUpdate.EtapaId}
                  onClick={(input) =>{
                    updateEtapa("EtapaId", input.target.dataset.value)
                  }
                  }
                  disabled={currentEtapaUpdate.exist?true:false}
                >
                  {listEtapaProcesal.map((item) => (
                    <MenuItem className="cmbTipoGestion_Item" value={item.Id}>
                      {item.Text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div>
                <FormControl fullWidth>
                  <DatePicker
                    required
                    label="Fecha de Inicio"
                    dateValue={
                      currentEtapaUpdate.AsigDEFechaInicio == null
                        ? null
                        : currentEtapaUpdate.AsigDEFechaInicio
                    }
                    setDateValue={setFecha1}
                    required={true}
                  />
                </FormControl>
              </div>
              <div>
                {currentEtapaUpdate.exist != null && (
                  <FormControl fullWidth>
                    <DatePicker
                      label="Fecha de Final"
                      dateValue={
                        currentEtapaUpdate.AsigDEFechaFinal == true
                          ? null
                          : currentEtapaUpdate.AsigDEFechaFinal
                      }
                      setDateValue={setFecha2}
                      required={true}
                    />
                  </FormControl>
                )}
              </div>
            </div>
            <FormControl fullWidth>
              <TextField
                id="outlined-basic"
                label="Comentario"
                className="txtComentario_ModalNuevaEtapa"
                variant="outlined"
                value={currentEtapaUpdate["AsigDEComentarios"]}
                multiline
                rows={2}
                maxRows={4}
                onChange={(input) =>
                  updateEtapa("AsigDEComentarios", input.target.value)
                }
              />
            </FormControl>
            <div className="modalAdicion__buttoncontainer">
              <button
                className="modalAdicion__btnCancelar"
                type="button"
                onClick={() => setShow(false)}
              >
                Cancelar
              </button>
              <button
                className="modalAdicion__btnRegistrar"
                // onClick={() => console.log(currentRow)}
                type="submit"
              >
                Registrar
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalEtapa1;
